define(['lodash', 'coreUtils', 'santa-components'], function (_, coreUtils, santaComponents) {
    'use strict';

    function createEvent(imageData, imageIndex, eventType) {
        return {
            item: imageData,
            timeStamp: coreUtils.loggingUtils.performance.now(),
            imageIndex,
            name: eventType
        };
    }

    function getPublicState(state) {
        return {
            currentIndex: _.get(state, 'currentIndex', 0),
            isPlaying: _.get(state, 'isPlaying')
        };
    }

    /**
     * @class core.tpaGallery
     *
     * @extends {santaComponents.mixins.compStateMixin}
     */
    return {
        mixins: [santaComponents.mixins.compStateMixin(getPublicState)],
        propTypes: {
            id: santaComponents.santaTypesDefinitions.Component.id.isRequired,
            compProp: santaComponents.santaTypesDefinitions.Component.compProp.isRequired,
            compData: santaComponents.santaTypesDefinitions.Component.compData.isRequired,
            sendPostMessage: santaComponents.santaTypesDefinitions.TPA.sendPostMessage.isRequired,
            mainPageId: santaComponents.santaTypesDefinitions.mainPageId.isRequired
        },
        componentDidMount() {
            this._itemChangedCallbacksToInvokeOnce = [];
        },
        processItemChanged(data) {
            const itemIndex = data.args[0],
                itemAtIndex = this.props.compData.items[itemIndex],
                galleryId = this.props.id;

            this.props.handleAction({
                'type': 'comp',
                'name': coreUtils.siteConstants.ACTION_TYPES.IMAGE_CHANGED,
                'sourceId': galleryId,
                'pageId': this.props.mainPageId
            }, createEvent(itemAtIndex, itemIndex, coreUtils.siteConstants.ACTION_TYPES.IMAGE_CHANGED));

            if (this.currentIndex !== itemIndex) {
                this.setState({currentIndex: itemIndex});
                _.invokeMap(this._itemChangedCallbacksToInvokeOnce, Function.call);
                this._itemChangedCallbacksToInvokeOnce = [];
            }
        },
        getInitialState() {
            this.prevCompProps = _.cloneDeep(this.props.compProp);
            return {
                currentIndex: 0,
                isPlaying: this.props.compProp.autoplay
            };
        },
        componentWillReceiveProps(nextProps) {
            const autoPlay = this.prevCompProps.autoplay;
            if (!_.isUndefined(autoPlay) && autoPlay !== nextProps.compProp.autoplay) {
                this.setState({isPlaying: nextProps.compProp.autoplay});
            }
            this.prevCompProps = _.cloneDeep(nextProps.compProp);
        },
        sendCommandMessage(cmd) {
            if (!this.isAlive || !this.componentInIframeReady) {
                return;
            }

            const message = {
                params: {
                    cmd
                },
                eventType: 'SETTINGS_UPDATED',
                intent: 'addEventListener'
            };

            this.props.sendPostMessage(this, message);
        },
        next(cb) {
            this._itemChangedCallbacksToInvokeOnce.push(cb);
            this.sendCommandMessage('next', cb);
        },
        prev(cb) {
            this._itemChangedCallbacksToInvokeOnce.push(cb);
            this.sendCommandMessage('previous', cb);
        }
    };
});
